<template>
  <div class="default-layout" :style="{ '--nav-height': navHeight + 'px' }">
    <CommonHeader />
    <div class="layout-wrapper">
      <aside v-if="menus.length" class="sidebar">
        <SidebarMenu />
      </aside>
      <div class="layout-right" :style="{ width: `calc(100% - ${menus.length ? 180 : 0}px)` }">
        <div class="layout-content">
          <router-view />
        </div>
        <AppFooter />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { useAppStore } from '@/stores/app';
import { computed, defineComponent } from 'vue';
import AppFooter from './AppFooter.vue';
import CommonHeader from './CommonHeader.vue';
import SidebarMenu from './SidebarMenu.vue';

export default defineComponent({
  name: 'DefaultLayout',
  components: {
    AppFooter,
    CommonHeader,
    SidebarMenu,
  },
  setup() {
    const appStore = useAppStore();
    const menus = computed(() => appStore.menus);
    const navHeight = computed(() => appStore.navHeight);

    return { menus, navHeight };
  },
});
</script>

<style scoped lang="scss">
.default-layout {
  height: 100vh;
  .layout-wrapper {
    display: flex;
    height: calc(100% - var(--nav-height));
  }
}
.sidebar {
  width: 180px;
  background: #1f2d3d;
  color: #fff;
  overflow-y: auto;
  padding: 12px 0;
  height: 100%;
}
.layout-right {
  width: calc(100% - 180px);
  height: 100%;
  overflow-y: auto;
}
.layout-content {
  padding: 20px 20px 12px;
  min-height: calc(100% - 28px);
}
</style>
